import { useQuery } from '@tanstack/react-query';

import { useApi } from '@/context';

export const planKeys = {
    all: ['plans'] as const,
    list: () => [...planKeys.all, 'list'] as const,
    detail: (planId: string) => [...planKeys.all, planId] as const,
};

export function usePlans() {
    const api = useApi();

    return useQuery({
        queryKey: planKeys.list(),
        queryFn: () => api.plans.getPlans(),
    });
}

export function usePlan(planId: string | undefined) {
    const api = useApi();

    return useQuery({
        queryKey: planKeys.detail(planId!),
        queryFn: () => api.plans.getPlan(planId!),
        enabled: !!planId,
    });
}
